import AbstractChatMessage from './AbstractChatMessage'
import { MessageTypes } from '@/constants/chat/MessageTypes'
import { JobOfferStagesInChat } from '@/constants/job/jobOfferStages'

export default class JobOfferChatMessage extends AbstractChatMessage {
  type = MessageTypes.JOB_OFFER
  budget?: string
  deadline?: number
  message: string
  offerId: number
  stage: JobOfferStagesInChat
  isEscrowed: boolean

  constructor(data: LX.JobOfferChatMessage) {
    super(data)
    this.message = data.body.message
    this.body = data.body.message
    this.budget = data.body.budget
    this.deadline = data.body.deadline
    this.offerId = data.entityId
    this.stage = data.body.stage
    this.isEscrowed = !!data.body.is_escrowed
  }

  static fromServer(data: LX.JobOfferChatMessage) {
    return new JobOfferChatMessage({ ...data, body: data.body })
  }

  getShortMessage() {
    return this.message
  }

  get deadlineInDays() {
    return (this.deadline || 0) / 86400
  }
}
